import { createContext, useContext, type PropsWithChildren } from "react";

export type ScoutTenantDocumentProposalStatus = "confirmed" | "declined";

export type ScoutTenantDocumentProposalContextValue = {
  respondedProposals: Record<string, ScoutTenantDocumentProposalStatus>;
  isProcessing: boolean;
  onConfirm: (input: {
    proposalId: string;
    documentIds: string[];
    totalProposedCount: number;
  }) => Promise<void>;
  onDecline: (input: { proposalId: string; totalProposedCount: number }) => Promise<void>;
};

const ScoutTenantDocumentProposalContext = createContext<
  ScoutTenantDocumentProposalContextValue | undefined
>(undefined);

export function ScoutTenantDocumentProposalProvider({
  value,
  children,
}: PropsWithChildren<{ value: ScoutTenantDocumentProposalContextValue }>) {
  return (
    <ScoutTenantDocumentProposalContext.Provider value={value}>
      {children}
    </ScoutTenantDocumentProposalContext.Provider>
  );
}

export function useScoutTenantDocumentProposalContext():
  | ScoutTenantDocumentProposalContextValue
  | undefined {
  return useContext(ScoutTenantDocumentProposalContext);
}
